// extracted by mini-css-extract-plugin
export default {"comments":"CommentList_comments__VqVBF","failComment":"CommentList_failComment__alhw5"};